import {
  Activity,
  Building2,
  KanbanSquare,
  Mail,
  Settings,
  Users,
  Video,
} from "lucide-react";
import { CanAccess } from "ra-core";
import { Link } from "react-router";
import { MobileContent } from "./MobileContent";
import MobileHeader from "./MobileHeader";

const links = [
  { to: "/companies", label: "Empresas", icon: Building2 },
  { to: "/deals", label: "Pipeline", icon: KanbanSquare },
  { to: "/meetings", label: "Reuniones", icon: Video },
  { to: "/email_messages", label: "Correos", icon: Mail },
  { to: "/activity", label: "Actividad", icon: Activity },
  { to: "/settings", label: "Configuración", icon: Settings },
];

export const MobileMorePage = () => (
  <>
    <MobileHeader>
      <h1 className="py-3 text-xl font-semibold">Más</h1>
    </MobileHeader>
    <MobileContent>
      <nav className="divide-y border-y" aria-label="Navegación adicional">
        {links.map(({ to, label, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className="flex min-h-14 items-center gap-3 px-2 text-base"
          >
            <Icon className="size-5 text-muted-foreground" />
            <span>{label}</span>
          </Link>
        ))}
        <CanAccess resource="sales" action="list">
          <Link
            to="/sales"
            className="flex min-h-14 items-center gap-3 px-2 text-base"
          >
            <Users className="size-5 text-muted-foreground" />
            <span>Integrantes</span>
          </Link>
        </CanAccess>
      </nav>
    </MobileContent>
  </>
);

MobileMorePage.path = "/more";
